import type {ConnectElementConfig} from '../ConnectElementList';

export const TreasuryEntryBannerConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryEntryBanner" */
      '../../../components/MoneyManagement/TreasuryEntryBanner/TreasuryEntryBanner'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  description:
    'Banner with various CTAs to show connected accounts new to v2 Treasury',
  friendlyName: 'Treasury Entry Banner',
};
